import React, { useState, useEffect } from "react";
import {
  Container, Table, Button, Form, Row, Col, Alert
} from "react-bootstrap";
import { FaTrash, FaEdit, FaCheck, FaTimes, FaPlus } from "react-icons/fa";
import axios from "axios";
import { Modal } from "react-bootstrap";


const API_URL = "https://autonotify-api.mobilibrasil.com/api/hosts";
const token = "Bearer AC48311f6664bbc01c45e34a5e33abff8e";

const Inventory = () => {
  const [hosts, setHosts] = useState({});
  const [filteredHosts, setFilteredHosts] = useState({});
  const [filters, setFilters] = useState({ hostname: "", entity_id: "", departamento: "" });
  const [newHost, setNewHost] = useState({ hostname: "", entity_id: "", departamento: "" });
  const [editMode, setEditMode] = useState(null);
  const [editData, setEditData] = useState({ hostname: "", entity_id: "", departamento: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importPreview, setImportPreview] = useState("");
  const [importedData, setImportedData] = useState(null);



  useEffect(() => {
    fetchHosts();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [hosts, filters]);

  const fetchHosts = () => {
    setLoading(true);
    axios.get(API_URL, { headers: { Authorization: token } })
      .then(res => {
        setHosts(res.data);
        setError("");
      })
      .catch(() => setError("Erro ao carregar os hosts."))
      .finally(() => setLoading(false));
  };

  const applyFilters = () => {
    const result = Object.fromEntries(
      Object.entries(hosts).filter(([hostname, data]) => {
        return (
          hostname.toLowerCase().includes(filters.hostname.toLowerCase()) &&
          String(data.entity_id || "").includes(filters.entity_id) &&
          data.departamento.toLowerCase().includes(filters.departamento.toLowerCase())
        );
      })
    );
    setFilteredHosts(result);
  };

  const validateImportData = (data) => {
    if (typeof data !== "object" || Array.isArray(data)) return false;
  
    return Object.entries(data).every(([hostname, values]) => {
      if (typeof hostname !== "string") return false;
      if (!values || typeof values !== "object") return false;
  
      const { entity_id, departamento } = values;
      const idValid = entity_id === undefined || typeof entity_id === "number";
      const deptValid = typeof departamento === "string" && departamento.length > 0;
  
      return idValid && deptValid;
    });
  };
  
  const handleAddHost = () => {
    const { hostname, entity_id, departamento } = newHost;
    if (!hostname.trim() || !departamento.trim()) {
      setError("Hostname e Departamento são obrigatórios.");
      return;
    }

    if (hosts[hostname]) {
      setError("Este hostname já existe.");
      return;
    }

    if (entity_id && isNaN(Number(entity_id))) {
      setError("Entity ID deve ser um número.");
      return;
    }

    axios.post(API_URL, {
      hostname,
      entity_id: entity_id ? Number(entity_id) : null,
      departamento
    }, { headers: { Authorization: token } })
      .then(() => {
        fetchHosts();
        setNewHost({ hostname: "", entity_id: "", departamento: "" });
      })
      .catch(() => setError("Erro ao adicionar host."));
  };

  const handleDelete = (hostname) => {
    if (!window.confirm(`Remover host "${hostname}"?`)) return;

    axios.delete(API_URL, {
      headers: { Authorization: token },
      data: { hostname }
    }).then(() => fetchHosts())
      .catch(() => setError("Erro ao remover host."));
  };

  const handleEdit = (hostname, data) => {
    setEditMode(hostname);
    setEditData({ hostname, ...data });
  };

  const handleCancelEdit = () => {
    setEditMode(null);
    setEditData({ hostname: "", entity_id: "", departamento: "" });
  };

  const handleSaveEdit = () => {
    const { hostname, entity_id, departamento } = editData;

    if (!hostname.trim() || !departamento.trim()) {
      setError("Hostname e Departamento são obrigatórios.");
      return;
    }

    if (entity_id && isNaN(Number(entity_id))) {
      setError("Entity ID deve ser um número.");
      return;
    }

    axios.put(API_URL, {
      old_hostname: editMode,
      hostname,
      entity_id: entity_id ? Number(entity_id) : null,
      departamento
    }, { headers: { Authorization: token } })
      .then(() => {
        fetchHosts();
        handleCancelEdit();
      })
      .catch(() => setError("Erro ao editar host."));
  };

  const handleExportJSON = () => {
    const blob = new Blob([JSON.stringify(hosts, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "hosts.json";
    link.click();
  };

  const handleImportJSON = (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const parsed = JSON.parse(event.target.result);
        setImportPreview("");
        setImportedData(null);
  
        if (!validateImportData(parsed)) {
          setImportPreview("❌ Estrutura inválida. Confira o modelo.");
          return;
        }
  
        setImportedData(parsed); // salva os dados para preview
      } catch {
        setImportPreview("❌ Arquivo não é um JSON válido.");
        setImportedData(null);
      }
    };
    reader.readAsText(file);
  };
  
  

  
  const handleExportCSV = () => {
    const headers = "Hostname,Entity ID,Departamento\n";
    const rows = Object.entries(hosts).map(([hostname, data]) =>
      `"${hostname}",${data.entity_id || ""},"${data.departamento}"`
    ).join("\n");
  
    const blob = new Blob([headers + rows], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "hosts.csv";
    link.click();
  };

  const handleImportConfirm = (data) => {
    Promise.all(Object.entries(data).map(([hostname, values]) =>
      axios.post(API_URL, { hostname, ...values }, { headers: { Authorization: token } })
    ))
      .then(() => {
        fetchHosts();
        setShowImportModal(false);
        setImportedData(null);
      })
      .catch(() => setImportPreview("❌ Falha ao enviar dados."));
  };
  
  const handlePrint = () => {
    window.print();
  };
  
  const renderFilters = () => (
    <tr>
      <th>
        <Form.Control
          size="sm"
          placeholder="Filtrar por Hostname"
          value={filters.hostname}
          onChange={(e) => setFilters({ ...filters, hostname: e.target.value })}
        />
      </th>
      <th>
        <Form.Control
          size="sm"
          placeholder="Filtrar por ID"
          value={filters.entity_id}
          onChange={(e) => setFilters({ ...filters, entity_id: e.target.value })}
        />
      </th>
      <th>
        <Form.Control
          size="sm"
          placeholder="Filtrar por Departamento"
          value={filters.departamento}
          onChange={(e) => setFilters({ ...filters, departamento: e.target.value })}
        />
      </th>
      <th></th>
    </tr>
  );

  return (
    <Container className="mt-4">
      <h2 className="text-center text-primary">Inventário de Hosts</h2>
      <Row className="mb-3">
  <Col className="d-flex gap-2 justify-content-end">
    <Button variant="secondary" onClick={handleExportJSON}>📤 JSON</Button>
    <Button variant="secondary" onClick={handleExportCSV}>📄 CSV</Button>
    <Button variant="primary" onClick={() => setShowImportModal(true)}>
        📥 Importar JSON
        </Button>

  </Col>
</Row>

      {error && <Alert variant="danger" dismissible onClose={() => setError("")}>{error}</Alert>}

      <Row className="mb-4">
        <Col md={4}>
          <Form.Control placeholder="Hostname" value={newHost.hostname}
            onChange={(e) => setNewHost({ ...newHost, hostname: e.target.value })} />
        </Col>
        <Col md={3}>
          <Form.Control placeholder="Entity ID" value={newHost.entity_id}
            onChange={(e) => setNewHost({ ...newHost, entity_id: e.target.value })} />
        </Col>
        <Col md={3}>
          <Form.Control placeholder="Departamento" value={newHost.departamento}
            onChange={(e) => setNewHost({ ...newHost, departamento: e.target.value })} />
        </Col>
        <Col md={2}>
          <Button variant="success" onClick={handleAddHost}><FaPlus /> Adicionar</Button>
        </Col>
      </Row>

      {loading ? (
        <div className="text-center my-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
        </div>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            {renderFilters()}
            <tr>
              <th>Hostname</th>
              <th>Entity ID</th>
              <th>Departamento</th>
              <th style={{ width: "10%" }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(filteredHosts).map(([hostname, data], idx) => {
              const isEditing = editMode === hostname;

              return (
                <tr key={idx}>
                  <td>
                    {isEditing
                      ? <Form.Control size="sm" value={editData.hostname}
                          onChange={(e) => setEditData({ ...editData, hostname: e.target.value })} />
                      : hostname}
                  </td>
                  <td>
                    {isEditing
                      ? <Form.Control size="sm" value={editData.entity_id || ""}
                          onChange={(e) => setEditData({ ...editData, entity_id: e.target.value })} />
                      : data.entity_id || "-"}
                  </td>
                  <td>
                    {isEditing
                      ? <Form.Control size="sm" value={editData.departamento}
                          onChange={(e) => setEditData({ ...editData, departamento: e.target.value })} />
                      : data.departamento}
                  </td>
                  <td>
                    {isEditing ? (
                      <>
                        <Button size="sm" variant="success" onClick={handleSaveEdit} className="me-2"><FaCheck /></Button>
                        <Button size="sm" variant="secondary" onClick={handleCancelEdit}><FaTimes /></Button>
                      </>
                    ) : (
                      <>
                        <Button size="sm" variant="light" className="me-2"
                          onClick={() => handleEdit(hostname, data)}>
                          <FaEdit />
                        </Button>
                        <Button size="sm" variant="light" onClick={() => handleDelete(hostname)}>
                          <FaTrash />
                        </Button>
                      </>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
          <Modal show={showImportModal} onHide={() => setShowImportModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Importar Hosts (.json)</Modal.Title>
  </Modal.Header>
  <Modal.Body>
  <p className="mb-2">Selecione um arquivo JSON no formato abaixo:</p>
  <pre className="bg-light p-2 rounded small">
{`{
  "host.exemplo.com": {
    "entity_id": 1,
    "departamento": "NOC"
  },
  "outro-host": {
    "entity_id": 6,
    "departamento": "Segurança"
  }
}`}
  </pre>

  <Form.Group controlId="formFile" className="mt-3">
    <Form.Control type="file" accept=".json" onChange={handleImportJSON} />
  </Form.Group>

  {importPreview && (
    <Alert variant="warning" className="mt-3">{importPreview}</Alert>
  )}

  {importedData && (
    <>
      <h6 className="mt-4">Pré-visualização:</h6>
      <Table striped bordered size="sm">
        <thead>
          <tr>
            <th>Hostname</th>
            <th>Entity ID</th>
            <th>Departamento</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(importedData).slice(0, 10).map(([hostname, data], idx) => (
            <tr key={idx}>
              <td>{hostname}</td>
              <td>{data.entity_id ?? "-"}</td>
              <td>{data.departamento}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      {Object.keys(importedData).length > 10 && (
        <p className="text-muted small">Exibindo os 10 primeiros registros.</p>
      )}
    </>
  )}
</Modal.Body>

{importedData && (
  <div className="text-end mt-3">
    <Button variant="success" onClick={() => handleImportConfirm(importedData)}>
      Confirmar Importação
    </Button>
  </div>
)}

</Modal>


        </Table>
        
      )}
    </Container>
  );
};

export default Inventory;
